module.exports = __webpack_public_path__ + "img/barre-6.ca51f789.png";